import { get } from "@devforce/trailhead-client-env";
export class Logger {
    constructor(opts = {}) {
        this.defaultOptions = {
            prefix: "[@devforce/trailhead-client-logger]: ",
        };
        this.options = this.defaultOptions;
        this.options = {
            ...this.defaultOptions,
            ...opts,
        };
    }
    info(msg, ...args) {
        // Don't log info in production environments
        if (get("DEBUG")) {
            console.info(`${this.options.prefix}${msg}`.trim(), ...args);
        }
    }
    warn(msg, ...args) {
        // Don't log warnings in production environments
        if (get("DEBUG")) {
            console.warn(`${this.options.prefix}${msg}`.trim(), ...args);
        }
    }
    error(msg, ...args) {
        var _a;
        console.error(`${this.options.prefix}${msg}`.trim(), ...args);
        /* eslint-disable */
        try {
            // @ts-ignore
            const error = msg instanceof Error ? msg : new Error(msg);
            // @ts-ignore
            (_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError(error);
        }
        catch (error) { }
        /* eslint-enable */
    }
}
export const logger = new Logger();
/**
 * Tests if the user's browser is officially supported
 */
export function isSupportedBrowser(userAgent = navigator.userAgent) {
    return /((CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS)[ +]+(18[_.]5|18[_.]([6-9]|\d{2,})|(19|[2-9]\d|\d{3,})[_.]\d+|26[_.]0|26[_.]([1-9]|\d{2,})|(2[7-9]|[3-9]\d|\d{3,})[_.]\d+)(?:[_.]\d+)?)|(Edge\/(140(?:\.0)?|140(?:\.([1-9]|\d{2,}))?|(14[1-9]|1[5-9]\d|[2-9]\d\d|\d{4,})(?:\.\d+)?))|((Chromium|Chrome)\/(140\.0|140\.([1-9]|\d{2,})|(14[1-9]|1[5-9]\d|[2-9]\d\d|\d{4,})\.\d+)(?:\.\d+)?)|(Version\/(18\.5|18\.([6-9]|\d{2,})|(19|[2-9]\d|\d{3,})\.\d+|26\.0|26\.([1-9]|\d{2,})|(2[7-9]|[3-9]\d|\d{3,})\.\d+)(?:\.\d+)? Safari\/)|(Firefox\/(143\.0|143\.([1-9]|\d{2,})|(14[4-9]|1[5-9]\d|[2-9]\d\d|\d{4,})\.\d+)\.\d+)|(Firefox\/(143\.0|143\.([1-9]|\d{2,})|(14[4-9]|1[5-9]\d|[2-9]\d\d|\d{4,})\.\d+)(pre|[ab]\d+[a-z]*)?)/.test(userAgent);
}
